import { jsx } from "react/jsx-runtime";
import TourIcon from "@mui/icons-material/Tour";
import { validateTidalLicense } from "../../base/index.js";
function Tour(props) {
  return /* @__PURE__ */ jsx(
    TourIcon,
    {
      "data-testid": "Tour",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Tour",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Tour.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Tour"
};
validateTidalLicense();
export {
  Tour
};
//# sourceMappingURL=Tour.js.map
